<template>
<div class="input-group-prepend">
    <slot></slot>
</div>
</template>

<script>
export default {

}
</script>